import Vue from 'vue';
import {HTTP} from "@/utils/httpCommonUtil";
import HttpMixin from "@/mixins/HttpMixin";
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import {
  EmailHistory,
  EmailHistoryAttachment,
  EmailHistorySummary
} from "@/components/communications/history/EmailHistoryModels";
import EmailHistoryDetails from "@/components/communications/history/EmailHistoryDetails.vue";

interface ParsedOutlookEmail {
  subject: string;
  body: string;
  createdDatetime: string;
  recipientName: string;
  recipientEmail: string;
  senderName: string;
  senderEmail: string;
  attachments: EmailHistoryAttachment[];
}

export default Vue.component('email-history', {
  name: 'EmailHistory',
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    EmailHistoryDetails
  },
  mixins: [HttpMixin],
  props: {
    providerId: { type: [String, Number], required: false },
    facilityId: { type: [String, Number], required: false }
  },
  data () {
    return {
      cardExpanded: false,
      emailHistory: [] as EmailHistorySummary[],
      isUploadingFile: false,
      historyRecord: null as EmailHistory | null,
      selectedHistoryId: 0
    }
  },
  async created() {
    await this.getEmails();
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getEmails();
      }
    },
    async getEmails() {
      const parameters = this.providerId ? `providerId=${this.providerId}` : `facilityId=${this.facilityId}`;
      this.emailHistory = (await this.httpGet(`/email-history?${parameters}`, 'Failed to load Email History') || []) as EmailHistorySummary[];
    },
    async filesChanged($event: Event) {
      try {
        this.isUploadingFile = true;
        const formData = new FormData();
        formData.append('emailFile', ($event.target as HTMLInputElement).files![0]);
        formData.append('facilityId', `${this.facilityId}`);
        formData.append('providerId', `${this.providerId}`);
        const response = await HTTP.post('/api/email-history/outlook-email', formData);
        if (!response.data.data) {
          throw new Error(response.data.message);
        }
        const email = response.data.data as ParsedOutlookEmail;
        this.historyRecord = this.createDefaultHistory();
        this.historyRecord.fromEmail = email.senderEmail;
        this.historyRecord.fromName = email.senderName
        this.historyRecord.toEmail = email.recipientEmail;
        this.historyRecord.toName = email.recipientName;
        this.historyRecord.subject = email.subject;
        this.historyRecord.body = email.body;
        this.historyRecord.sentDatetime = email.createdDatetime;
        this.historyRecord.attachments = email.attachments.map(attachment => ({ ...attachment, selected: false }));
      } catch (e) {
        console.error(e);
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred uploading Email.'
        });
      } finally {
        this.isUploadingFile = false;
        (this.$refs.historyFileInput as HTMLInputElement).value = '';
      }
    },
    createDefaultHistory(): EmailHistory {
      return {
        id: 0,
        providerId: Number(this.providerId),
        facilityId: Number(this.facilityId),
        title: null,
        notes: null,
        fromEmail: '',
        fromName: '',
        toEmail: '',
        toName: '',
        subject: '',
        body: '',
        sentDatetime: '',
        uploadedDatetime: '',
        uploadedByAppUserId: 0,
        attachments: []
      };
    },
    cancel() {
      this.historyRecord = null;
      this.selectedHistoryId = 0;
    },
    async loadHistory(id: number) {
      if (id === this.selectedHistoryId) {
        this.cancel();
        return;
      }
      this.historyRecord = await this.httpGet(`/email-history/${id}`, 'Failed to load Email History Details') as EmailHistory;
      this.selectedHistoryId = id;
    },
    async saved() {
      this.cancel();
      await this.getEmails();
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/communications/history/EmailHistory.ts